import React, { useEffect } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { withRouter } from "next/router";
import { inject, observer } from "mobx-react";
import withCustomComponent from "ui/components/withCustomComponent";
import { usePaymentRoutes } from "@portal/env/hooks/payments/usePaymentRoutes";

export const UnpaidBookingsNotice = withCustomComponent('UnpaidBookingsNotice')(
  inject(
    'bookingsStore',
    'appStore'
  )(
    withRouter(
      observer(({ bookingsStore, appStore, componentName, router }) => {
        const { t } = useTranslation();

        const paymentRoutes = usePaymentRoutes();

        let interval = null;

        useEffect(() => {
          interval = setInterval(
            () => bookingsStore.loadUnpaidBookings(),
            60000
          );
          return () => clearInterval(interval);
        }, []);

        return (
          (<div className="d-flex flex-row align-items-center ">
            <div data-component-name={componentName}>
              {t(
                'Your bookings will be cancelled if not paid within {{minutes}} minutes',
                { minutes: Math.floor(bookingsStore.unpaidBookings.TimeToPay) }
              )}
            </div>
            {router.pathname.indexOf(paymentRoutes.checkout_payment) == -1 && (
              <div>
                <Link
                  href={paymentRoutes.checkout_payment}
                  className="ml-20 btn btn-sm"
                  >
                  {t('Pay now')}
                </Link>
              </div>
            )}
          </div>)
        );
      })
    )
  )
);
